import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, EffectFade } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-fade";
import "./julWorks.css";

// Rastgele sıralamak için bir fonksiyon
const shuffleArray = (array) => {
    return array.sort(() => Math.random() - 0.5);
  };

  const JulWorks = () => {
    const [images, setImages] = useState([]);

    // Sayfa her yüklendiğinde yeni bir sıralama oluştur
    useEffect(() => {
      const shuffledImages = shuffleArray(
        Array.from(
          { length: 11 },
          (_, i) =>
            `/images/AboutPhotos/resim${String(i + 1).padStart(3, "0")}.jpg`
        )
      );
      setImages(shuffledImages);
    }, []); // Bu sadece sayfa ilk yüklendiğinde çalışır
  
    return (
      <div className="julworks-page">
        <Swiper
          modules={[Autoplay, EffectFade]}
          slidesPerView={1}
          effect="fade"
          fadeEffect={{ crossFade: true }}
          autoplay={{ delay: 3000, disableOnInteraction: false }}
          loop={true}
          speed={1500}
          className="julworks-slider"
        >
          {images.map((image, index) => (
            <SwiperSlide key={index} className="slide-container">
              <img
                src={image}
                alt={`Slide ${index + 1}`}
                className="julworks-slide-image"
              />
              <img src="/images/logo.png" alt="Logo" className="logo-overlay" />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    );




  }

  export default JulWorks;